export default __webpack_public_path__ + "static/media/error.bdf50afe.svg";